<template >
    <div ref="Alert" >
    <div >

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->       
        <div style="padding-left: 0; padding: 10px;" class="d-block text-center ; row no-margin; row no-border" >         
            <form @submit.prevent="appliquer(selected_system)">
                <table class="table text-center font-weight-light table-borderless" style="margin-top: 0px; margin-bottom: 0px;" >


                    <tr style="text-align:left;" class="align-middle col-12">
                        <td style="text-align: left; font-weight: bold;">Alertes :</td>
                    </tr>
                    <tr style="text-align:left; margin: 0px; padding: 0px;" class="align-middle row">
                        <td style="text-align:left;" class="align-middle col-4">
                            Agenda :
                            <!--<font-awesome-icon icon="fa-regular fa-circle-question" 
                            v-b-tooltip.hover="'toutes les alarmes qui concernent l agenda: demande, validation, suppression, clôture de réservation'"
                            v-b-tooltip.click="'toutes les alarmes qui concernent l agenda: demande, validation, suppression, clôture de réservation'"/>-->
                            <span id="agenda"  @click="showGroupTooltip('tooltip_group_agenda')" >
                                <font-awesome-icon icon="fa-regular fa-circle-question"/>
                            </span>
                            <b-tooltip  target="agenda" 
                                        placement="auto" 
                                        v-bind:triggers="mobile==true ?'click' :'hover'" 
                                        v-bind:ref="'tooltip_group_agenda'">
                                Toutes les alarmes qui concernent l'agenda: demande, validation, suppression et clôture de réservation.
                            </b-tooltip>
                            
                                <!--<font-awesome-icon
                                icon="fa-regular fa-circle-question"
                                v-b-tooltip.hover="mobile ? false : 'Toutes les alarmes qui concernent l agenda: demande, validation, suppression, clôture de réservation' "
                                v-b-tooltip.click="mobile ? 'Toutes les alarmes qui concernent l agenda: demande, validation, suppression, clôture de réservation' : true"
                                />-->
                            
                           
                        </td>
                        <td style="text-align:left; margin: 0px" class="align-middle col-6" > 
                            <input class="align-middle mr-2 ml-2 mb-2" type="radio" id="one" :value="true" v-model="agenda_alert" > <span  :for="true" class="align-middle mr-2  mb-2"> Oui </span>
                            <input class="align-middle mr-2 ml-2  mb-2" type="radio" id="two" :value="false" v-model="agenda_alert" > <span :for="false" class="align-middle  mb-2"> Non </span>
                        </td>
                        <td style="text-align:left; padding: 0px; margin: 0px" class="align-middle col-2" > 
                        </td>
                    </tr>
                    <tr style="text-align:left; margin: 0px; padding: 3px;" class="row">
                        <td style="text-align:left;"  class="align-middle col-4">
                            Activités :
                            <span id="activite" @click="showGroupTooltip('tooltip_group_activite')" >
                                <font-awesome-icon icon="fa-regular fa-circle-question"/>
                            </span>
                            <b-tooltip target="activite" placement="auto" auto-hide  v-bind:triggers="mobile==true ?'click' :'hover'" v-bind:ref="'tooltip_group_activite'" >   
                                   
                                Toutes les alarmes qui concernent l'utilisation de matériel hors réservation.
                            </b-tooltip>
                            
                        </td>
                        <td  style="text-align:left; margin: 0px" class="align-middle col-6"> 
                            <input class="align-middle mr-2 ml-2  " type="radio" id="one" :value="true" v-model="horsResa_alert"> <span  :for="true" class="align-middle mr-2  "> Oui </span>
                            <input class="align-middle mr-2 ml-2  " type="radio" id="two" :value="false" v-model="horsResa_alert"> <span :for="false" class="align-middle "> Non </span>
                        </td>
                        <td style="text-align:left; margin: 0px; padding: 0px;" class="align-middle col-2">
                            <button class="btn btn-icon btn-rounded btn-primary"     
                                type="button"
                                @click="seuilResa()">
                                <i class="ti-settings"></i>
                            </button>
                            
                                
                        </td>
                    </tr>
                    <tr style="text-align:left; margin: 0px; padding: 3px;" class="row">
                        <td  style="text-align:left; " class="align-middle col-4">
                             Periodique :
                             <span id="periodic" @click="showGroupTooltip('tooltip_group_periodic')" >
                                <font-awesome-icon icon="fa-regular fa-circle-question"/>
                            </span>
                            <b-tooltip  target="periodic" 
                                        placement="auto"  
                                        v-bind:triggers="mobile==true ?'click' :'hover'" 
                                        v-bind:ref="'tooltip_group_periodic'">    
                                Alarmes périodique sur le matériel.
                            </b-tooltip>
                            
                        </td>
                        <td style="text-align:left; margin: 0px" class="align-middle col-6"> 
                            <input  class="align-middle mr-2 ml-2 " type="radio" id="one" :value="true" v-model="periodic_alert" > <span  :for="true" class="align-middle mr-2  "> Oui </span>
                            <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false"  v-model="periodic_alert" > <span :for="false" class="align-middle "> Non </span>
                        </td>
                        <td style="text-align:left; margin: 0px; padding: 0px;" class="align-middle col-2">
                            <!--<button class="btn btn-icon btn-rounded" 
                                v-bind:class="[(this.periodicAlarm.id !=0 ) ? 'btn-primary' : 'btn-flat']"
                                type="button"
                                @click="periodicConfig_open()">
                                <i class="ti-settings"></i>
                            </button>-->
                            <button class="btn btn-icon btn-rounded btn-primary" 
                                
                                type="button"
                                @click="periodicConfig_open()">
                                <i class="ti-settings"></i>
                            </button>
                            
                                
                        </td>
                    </tr>
                    <tr style="text-align:left; margin: 0px; padding: 3px;" class="align-middle row">
                        <td  style="text-align:left;" class="align-middle col-4">
                            Seuil :
                             <span id="seuil" @click="showGroupTooltip('tooltip_group_seuil')" >
                                <font-awesome-icon icon="fa-regular fa-circle-question"/>
                            </span>
                            <b-tooltip target="seuil" placement="auto"  v-bind:triggers="mobile==true ?'click' :'hover'" v-bind:ref="'tooltip_group_seuil'">   
                                   
                                Alarmes seuil sur le matériel.
                            </b-tooltip>
                        </td>
                        <td  style="text-align:left; margin: 0px" class="align-middle col-6"> 
                            <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="seuil_alert" > <span  :for="true" class="align-middle mr-2"> Oui </span>
                            <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="seuil_alert"> <span :for="false" class=align-middle> Non </span>
                        </td>
                        <td  style="text-align:left; margin: 0px; padding: 0px;" class="align-middle col-2">
                            <!--<button class="btn btn-icon btn-rounded" 
                                v-bind:class="[(this.seuilAlarm.id !=0 ) ? 'btn-primary' : 'btn-flat']"
                                type="button"
                                @click="seuilConfig_open()">
                                <i class="ti-settings"></i>
                            </button>-->
                            <button class="btn btn-icon btn-rounded btn-primary" 
                                
                                type="button"
                                @click="seuilConfig_open()">
                                <i class="ti-settings"></i>
                            </button>
                        </td>
                    </tr>
                    <tr style="text-align:left; margin: 0px; padding: 3px;" class="align-middle row" >
                        <td  style="text-align:left;" class="align-middle col-4">
                            GPS :
                             <span id="gps" @click="showGroupTooltip('tooltip_group_gps')" >
                                <font-awesome-icon icon="fa-regular fa-circle-question"/>
                            </span>
                            <b-tooltip target="gps" placement="auto"  v-bind:triggers="mobile==true ?'click' :'hover'" v-bind:ref="'tooltip_group_gps'" >   
                                   
                                Alarmes GPS: Sortie de zone sur le matériel.
                            </b-tooltip>
                        </td>
                        <td style="text-align:left; margin: 0px" class="align-middle col-6"> 
                            <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="gps_alert"> <span  :for="true" class="align-middle mr-2"> Oui </span>
                            <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="gps_alert"> <span :for="false" class=align-middle> Non </span>
                        </td>
                        <td style="text-align:left; margin: 0px; padding: 0px;" class="align-middle col-2">
                            <!--<button class="btn btn-icon btn-rounded" 
                                v-bind:class="[(this.gpsAlarm.id !=0 ) ? 'btn-primary' : 'btn-flat']"
                                type="button"
                                @click="map3_modal_open">
                                <i class="ti-settings"></i>
                            </button>-->
                            <button class="btn btn-icon btn-rounded btn-primary" 
                                
                                type="button"
                                @click="map3_modal_open">
                                <i class="ti-settings"></i>
                            </button>

                        </td>
                    </tr>
                    
                    <tr style= "margin: 10px; padding: 10px;">
                        <td  class="align-middle" colspan="3">
                            <div  class="text-center mt" >
                                <b-button class="btn btn-default mr-5" variant="secondary" :disabled="isBusy" @click="annuler()"> Annuler </b-button>
                                <b-button type="submit" class="btn btn-primary mr-3"> Appliquer </b-button>    
                            </div>
                             <div class="alert alert-danger" role="alert" v-if="error">
                                Une erreur est surevenue ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                        </td>
                    </tr>     
                </table>        
            </form>               
        </div>
                 
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
<!-- ######################################################################################### -->
        
        <b-modal ref="map3_popup" hide-footer centered title=" Cliquer pour selectionner le centre de la zone autorisée"  >
            <v-gps-alarm
                :selected_system="selected_system"
                :action="this.action"
                :gps_alarm="gpsAlarm"
                @gps-alarm-done = "close_gps_alarm_modal"
                
            ></v-gps-alarm>
        </b-modal>
        <b-modal ref="seuilConfig_popup" hide-footer centered title="Seuil Config"  size="xl">
            <v-seuil-config
                :selected_system="selected_system"
                :action="this.action"
                :seuil_alarm="seuilAlarm"
                @seuil-config-done = "close_seuilConfig"
            ></v-seuil-config>
        </b-modal>
        <b-modal ref="periodicConfig_popup" hide-footer centered title="Periodic Config"  size="xl">
            <v-periodic-config
                :selected_system="selected_system"
                :periodic_alarm="periodicAlarm"
                @periodic-config-done = "close_periodicConfig"
            ></v-periodic-config>
        </b-modal>
        <b-modal ref="seuilResa_popup" hide-footer centered title="Seuil Hors Réservation Config"  size="small">
            <v-seuilResa
                :selected_system="selected_system"
                @seuilResa-done = "close_seuilResa"
            ></v-seuilResa>
        </b-modal>
    </div>
    </div> 
</template>

<script>
    import api from "../../config/_api";
    import SelectGpsAlarm from "../Map/SelectGpsAlarm";
    import PeriodicConfig from "./PeriodicConfig";
    import SeuilConfig from "./SeuilConfig";
    import SeuilResa from "./SeuilResa";

export default {
    name :"SystemWarnings",
    components:{
        'v-gps-alarm': SelectGpsAlarm,
        'v-seuil-config' : SeuilConfig ,
        'v-seuilResa' : SeuilResa ,
        'v-periodic-config': PeriodicConfig,
    },

    data (){
        return {
            window: {
                width: 0,
                height: 0
            },
            unit: null,
            unit_t: null,
            showModal: true,
            mobile: false,
            gpsAlarm: {
                id: 0,
                rayon: null,
                longitude: null,
                latitude: null,
            },
            periodicAlarm:{
                id :0,
                alarm_name: null,
                unit_type: null,
                dest_id: null,
                periodicity: null
            },
            seuilAlarm:{
                id :0,
                alarm_name: null,
                unit_type: null,
                seuil_type: null,
                dest_id: null,
                seuil: null
            },
			isBusy: false,
            agenda_alert: false,
            horsResa_alert: false,
            periodic_alert : false,
            seuil_alert: false,
            gps_alert: false,
            mask_agenda : 0x06,
            mask_hors_resa : 0x08,
            mask_seuil : 0x10,
            mask_periodic : 0x20,
            mask_gps : 0x40,
            type: 0,
            computed_status: 0,
            system: null,
            width: 450 ,
            height:650,
            error: false, // initialiser l'objet error {pour la fonction alerte} 
            coordinates: {
                latitude: null,
                longitude: null
            }
        }
    },
    
    mounted (){
        this.gpsAlarm = this.gps_alarme();
        this.seuilAlarm =this.seuil_alarme();
        this.periodicAlarm = this.periodic_alarme();
        setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    },
    props :{
        selected_system: {
            type: Object,
            required: false,
            default: function () {
                return {
                    name : "",
                    code : ""
                }
            }
        },
        action : ""
    },
    created() {
        this.analyse_status();
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        agenda_alert: function() {
            this.updateStatus();
        },
        horsResa_alert: function() {
            this.updateStatus();
        }
    },
    methods : { 
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            this.mobile=(this.window.width<1080)? true : false ;
            if (this.mobile){
                this.width=327;
                this.height=760;
            }
        },

        updateStatus() {
            this.computed_status = 1 + this.agenda_alert*this.mask_agenda + this.horsResa_alert*this.mask_hors_resa + this.seuil_alert*this.mask_seuil + this.periodic_alert*this.mask_periodic + this.gps_alert*this.mask_gps; 
            return this.computed_status;
        },
        //recuperation des tableaux d'alarmes systèmes
        //si l'alarme gps existe sur le system retourner une liste
        
        gps_alarme(){
            let gpsAlarm= {
                id: 0,
                rayon: null,
                longitude: null,
                latitude: null,
            };
            this.$store.dispatch('system_alarm_gps/getSysGps', {
                system_id: this._props.selected_system.id,
                    
                }).then(response => {
                    if (response.length>0){
                        gpsAlarm.id = response[0].id;
                        gpsAlarm.longitude = response[0].longitude;
                        gpsAlarm.latitude = response[0].latitude;
                        gpsAlarm.rayon = response[0].rayon;
                        return gpsAlarm;
                    }
                }).catch((error) => {
                    this.error = true; 
                    return null;
                })
                return gpsAlarm;
        },
        //si l'alarme seuil existe sur le system retourner une liste
        
        seuil_alarme(){
            let seuilAlarm= {
                id: 0,
                alarm_name: null,
                unit_type: null,
                seuil_type: null,
                dest_id: null,
                seuil: null
            };
            this.$store.dispatch('system_alarm_seuil/getSysSeuil', {
                system_id: this._props.selected_system.id,
            }).then(response => {
                if (response.length>0){
                    //seuilAlarm = response[0];
                    seuilAlarm.id = response[0].id;
                    seuilAlarm.alarm_name = response[0].alarm_name;
                    seuilAlarm.unit_type = response[0].unit_type;
                    seuilAlarm.dest_id = response[0].dest_id;
                    seuilAlarm.unit_type = response[0].unit_type;
                    seuilAlarm.seuil_type = response[0].seuil_type;
                    seuilAlarm.seuil = response[0].seuil;
                    return seuilAlarm;
                }
            }).catch((error) => {
                this.error = true;
                return null;
            })
            return seuilAlarm;
        },
            
        //si l'alarme periodique existe sur le system retourner une liste
        
        periodic_alarme(){
            let periodicAlarm= {
                id: 0,
                alarm_name: null,
                unit_type: null,
                dest_id: null,
                ref_val: null,
                ref_date: null,
                periodicity: null
            };
            this.$store.dispatch('system_alarm_periodic/getSysPeriodic', {
                system_id: this._props.selected_system.id,
                            
            }).then(response => {
                if (response.length>0){
                    periodicAlarm.id = response[0].id;
                    periodicAlarm.alarm_name = response[0].alarm_name;
                    periodicAlarm.dest_id = response[0].dest_id;
                    periodicAlarm.unit_type = response[0].unit_type;
                    periodicAlarm.periodicity = response[0].periodicity;
                    periodicAlarm.ref_val = response[0].ref_val;
                    periodicAlarm.ref_date = response[0].ref_date;
                    return periodicAlarm;
                }
            }).catch((error) => {
                this.error = true;
                return null;
            })
            return periodicAlarm;
        },

        analyse_status(){
            if(this.selected_system!=null){

                this.computed_status = this.selected_system.status;
               
                if((this.selected_system.status & this.mask_agenda)>0){
                    this.agenda_alert = true;
                }
                
                if((this.selected_system.status & this.mask_hors_resa)>0){
                    this.horsResa_alert = true;
                }
               
                if((this.selected_system.status & this.mask_seuil)>0){
                    this.seuil_alert = true;
                }
                
                if((this.selected_system.status & this.mask_periodic)>0){
                    this.periodic_alert = true;
                }
                
                if((this.selected_system.status & this.mask_gps)>0){
                    this.gps_alert = true;
                }

            }
        },
        
        show (event) {
            this.system = event;
            this.$bvModal.show("modal-info");
        },
        annuler(){    
            this.updateStatus();    
            if((this.computed_status!=this.selected_system.status)){
    
                //console.log('La valeur du sélecteur  a changé !');
                this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir annuler les modifications ?', {
					title: 'Annuler les modifications',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
                    centered: true,
				}).then(value => {
					if(value) {
                      this.$emit('alert-done')
                    }
				})
            }
            else{
                this.$emit('alert-done')
            }
            
        },
        showGroupTooltip(groupRef){
            if(this.mobile){
                var $tooltip = groupRef;
                this.$refs[groupRef].$emit('open');
                setTimeout(function ()  { 
                    this.$refs[$tooltip].$emit('close');
                }.bind(this,$tooltip),2000);
            }
        },
    
        appliquer(){
  
            let data = {
                status: this.updateStatus(),
            };

            this.axios({url: api.url + 'systems/' + this.selected_system.id + '?structure_id=' + this.$store.getters.structure_id, data: data, method: 'PUT' })
                .then(resp => {
                    if(resp.status < 400){
                        //this.$router.push("/systems/index");
                        this.$emit('alert-done',{'error' : false, 'resp': resp});
                        }
                    })
                .catch(err => {
                    this.error = true;
                });

        },
        map3_modal_open() {
            this.$refs.map3_popup.show()
        },
        
        close_gps_alarm_modal(result) {
            if(!result.error){
                this.gpsAlarm = result.resp;
            }
            this.$refs.map3_popup.hide();
        },
        seuilConfig_open() {
            this.$refs.seuilConfig_popup.show();
        },
        close_seuilConfig(result) {
            if(!result.error){
                this.seuilAlarm = result.resp;
            }
            this.$refs.seuilConfig_popup.hide();
        },
        periodicConfig_open() {
            this.$refs.periodicConfig_popup.show();
        },
        
        close_periodicConfig(result) {
            if(!result.error){
                this.periodicAlarm = result.resp;
            }
            this.$refs.periodicConfig_popup.hide();
        },
       
 
        seuilResa() {
            this.$refs.seuilResa_popup.show();
        },
        
        close_seuilResa(result) {
            if(!result.error){
                this.selected_system.seuil_hors_resa = result.resp.seuil_hors_resa;
            }
            this.$refs.seuilResa_popup.hide();
        },
    },

}

</script>
<style>
    .form-check-inline {
        display: flex;
        align-items: center;
    }
    .form-check-inline + .form-check-inline {
        margin-left: 10px;
    }
    .flex-column {
        display: flex;
        flex-direction: column;
    }
</style>

